import {Button} from '@/components/ui/button/Button'
import {useTranslation} from '@/translations/i18n'
import {ComponentType, MouseEvent} from 'react'
import {useOutletContext} from 'react-router-dom'
import {useGenerateFm22} from '../../queries/useGenerateFm22'
import {ProjectExtended} from '../../types'
import {Spinner} from '@/components/ui/spinner/Spinner'
import dayjs from 'dayjs'
import {buildFile} from '@/utilities/helpers'

export const PrintFm22Trigger = ({
    isDisabled,
    customTrigger: CustomTrigger,
    onPrintSuccess
}: {
    isDisabled?: boolean
    customTrigger?: ComponentType<{disabled: boolean; onClick: (event?: MouseEvent<HTMLElement>) => void}>
    onPrintSuccess?: () => void
}) => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {mutate: generateFm22, isPending} = useGenerateFm22(
        {projectId: project.id},
        {
            onSuccess: data => {
                const pdfFile = buildFile({
                    extension: 'pdf',
                    fileName: `fm22-${project.code}-${dayjs().format('DD-MM-YYYY')}`,
                    data
                })
                const pdfUrl = URL.createObjectURL(pdfFile)
                window.open(pdfUrl, '_blank')
                onPrintSuccess?.()
            }
        }
    )

    const handlePrintFm22 = () => {
        generateFm22({signature: true})
    }

    return CustomTrigger ? (
        <CustomTrigger disabled={!!isDisabled || isPending} onClick={handlePrintFm22} />
    ) : (
        <Button disabled={!!isDisabled || isPending} onClick={handlePrintFm22} variant="primaryNeutral">
            {t('commons:print')}
            {isPending && <Spinner />}
        </Button>
    )
}
